// overrider default scroll behaviour to empty,
// because it breaks the custom locomotive scroll
// app should manually handle hash navigation
export default function () {}
